/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogSummaryDto } from '../../models/blog-summary-dto';

export interface ApiProductsqueryBlogsGet$Plain$Params {
}

export function apiProductsqueryBlogsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProductsqueryBlogsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlogSummaryDto>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryBlogsGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BlogSummaryDto>>;
    })
  );
}

apiProductsqueryBlogsGet$Plain.PATH = '/api/productsquery/blogs';
